module.exports = __webpack_public_path__ + "img/account.4eb15109.svg";